import {
  AccountBox as AccountBoxIcon,
  AccountCircle as AccountCircleIcon,
  CallMade as CallMadeIcon,
  CallMissedOutgoing as CallMissedOutgoingIcon,
  CancelScheduleSend as CancelScheduleSendIcon,
  ContactMail as ContactMailIcon,
  Drafts as DraftsIcon,
  ImportantDevices as ImportantDevicesIcon,
  PersonPin as PersonPinIcon,
  PieChart as PieChartIcon,
  Reply as ReplyIcon,
  ShowChart as ShowChartIcon,
  Telegram as TelegramIcon,
  Timeline as TimelineIcon,
  TrendingDown as TrendingDownIcon,
  TrendingUp as TrendingUpIcon
} from '@material-ui/icons';
import {
  AvgHandleTimeCallIcon,
  CandidatesIcon,
  CompaniesIcon,
  InBoundCall,
  JobOrdersIcon,
  MissedCall,
  OutBoundCall,
  ReadSMSIcon,
  ReceivedSMSIcon,
  SentSMSIcon,
  SvgNoConnectedCallFilled,
  TotalCallsIcon,
  TotalCallTimeIcon,
  UnreadSMSIcon
} from 'UI/res';

export const BULK_ICONS_MAP = {
  bouncedBulk: CallMissedOutgoingIcon,
  droppedBulk: TrendingDownIcon,
  generalAutomatedReplyRatio: ReplyIcon,
  generalBulk: TelegramIcon,
  generalOpenRatio: PieChartIcon,
  generalDirectReplyRatio: CallMadeIcon,
  marketingAutomatedReplyRatio: ShowChartIcon,
  marketingBulk: ImportantDevicesIcon,
  marketingOpenRatio: TrendingUpIcon,
  marketingDirectReplyRatio: TrendingUpIcon,
  reachedBulk: AccountBoxIcon,
  recruitingAutomatedReplyRatio: ContactMailIcon,
  recruitingBulk: PersonPinIcon,
  recruitingOpenRatio: DraftsIcon,
  recruitingDirectReplyRatio: AccountCircleIcon,
  sentBulk: TimelineIcon,
  spamBulk: CancelScheduleSendIcon
};

export const ICONS_MAP = {
  ...BULK_ICONS_MAP,
  avgHandleTimeCall: AvgHandleTimeCallIcon,
  candidate: CandidatesIcon,
  company: CompaniesIcon,
  inboundCall: InBoundCall,
  jobOrder: JobOrdersIcon,
  missedCall: MissedCall,
  noConnectedCall: SvgNoConnectedCallFilled,
  outboundCall: OutBoundCall,
  readSMS: ReadSMSIcon,
  receivedSMS: ReceivedSMSIcon,
  sentSMS: SentSMSIcon,
  totalCalls: TotalCallsIcon,
  totalTime: TotalCallTimeIcon,
  unreadSMS: UnreadSMSIcon
};
